import Vue from 'vue';

import { hasPermission } from '~/helpers/permission';

const handler = (el, binding, vnode) => {
  if (binding.value.changeProperties) {
    Object.keys(binding.value.changeProperties).forEach((key) => {
      vnode.context[key] = binding.value.changeProperties[key];
    });
  } else if (binding.value.hidden) {
    el.style.display = 'none';
  } else {
    el.remove();
  }
  if (binding.value.onRemoved) {
    binding.value.onRemoved();
  }
};

const verify = (el, binding, vnode) => {
  const academicMainId = binding.value.academicMainId;
  const academicMainTypeId = binding.value.academicMainTypeId;
  const isMarketplace = binding.value.isMarketplace;
  const topicTypeId = binding.value.topicTypeId;
  const alias = binding.value.alias;
  const aliases = binding.value.aliases;
  const permissions = vnode.context.$store.state.plataforma.courses.userPermissions;

  if (aliases) {
    const hasPermissions = aliases.map(alias => hasPermission(academicMainId, academicMainTypeId, isMarketplace, topicTypeId, alias, permissions));

    if (hasPermissions.every(element => element === false)) {
      handler(el, binding, vnode);
    }
  } else {
    if (alias && !hasPermission(academicMainId, academicMainTypeId, isMarketplace, topicTypeId, alias, permissions)) {
      handler(el, binding, vnode);
    }
  }
};

Vue.directive('permission', {
  inserted: function(el, binding, vnode) {
    verify(el, binding, vnode);
  },
  update: function(el, binding, vnode) {
    verify(el, binding, vnode);
  }
});
